module.exports = __webpack_public_path__ + "img/Gibson-Light.884f58a6.svg";